export default __webpack_public_path__ + "static/logo_white-d242dbff030c335428db447d2448db17.png";